<template>
  <!-- 消除金额-->
  <el-dialog
    :lock-scroll="false"
    :close-on-click-modal="false"
    title="消除金额"
    :visible="reduceMoney.dialogFormVisible"
    width="500px"
    @close="onCancleBtn"
  >
    <el-form
      @submit.native.prevent
      style="width: 100%"
      label-position="right"
      ref="form"
      :model="form"
      :rules="rules"
    >
      <el-form-item label="金额" prop="money">
        <el-input v-model.trim="form.money"></el-input>
      </el-form-item>
    </el-form>
    <section class="money" @click="fillMoney">充值金额:<span>{{recharge}}</span> 赠送金额:<span>{{gift}}</span> 共<span>{{total}}</span></section>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onConfirmBtn">确 定</el-button>
      <el-button @click="onCancleBtn">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { reqReduceMoney } from "@/api/url";
export default {
  props: {
    reduceMoney: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      form: {
        money: 0,
      },
      rules: {
        money: [
          { required: true, message: "请输入金额", trigger: "blur" },
          // {type:"number",message:"请输入数字",trigger:"blur"}
        ],
      },
    };
  },
  computed:{
      recharge:{
          get(){
              return Number(this.reduceMoney.money).toFixed(2)
          }
      },
      gift:{
          get(){
              return Number(this.reduceMoney.giftAmount).toFixed(2)
          }
      },
      total:{
          get(){
              return (Number(this.reduceMoney.money)+Number(this.reduceMoney.giftAmount)).toFixed(2)
          }
      }
  },
  methods: {
      fillMoney(e){
          const {target:{nodeName,textContent}}=e;
          if(nodeName==="SPAN"){
                this.form.money=textContent;
          }
      },
    onConfirmBtn() {
      this.$postRequest(reqReduceMoney(), {
        id: this.reduceMoney.userId,
        money: this.form.money,
      }).then((data) => {
        const { status } = data;
        if (status === 200) {
          this.$emit("func", "success");
          this.$message({
            type: "success",
            message: data.message,
          });
        } else {
          this.$message.error(data.message);
        }
      });
    },
    onCancleBtn() {
      this.$refs["form"].resetFields();
      this.$emit("func", "cancle");
    },
  },
};
</script>
<style scoped>
.money span{
    cursor: pointer;
    color:#409EFF;
}
</style>